import {
  CLEAR_ADMINISTRATORS,
  CLEAR_ADMINISTRATORS_OPTIONS,
  LOAD_ADMINISTATORS,
  SAVE_ADMINISTRATORS_OPTIONS
} from '../actions/administratorsActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0
  },
  items: [],
  count: 0
};

const administratorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ADMINISTATORS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count
      };
    }
    case SAVE_ADMINISTRATORS_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_ADMINISTRATORS_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case CLEAR_ADMINISTRATORS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default administratorsReducer;
